import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import './AddPromotion.css';
import BusinessSidebar from "../../BusinessSidebar";
import Header from "../../BusinessHeaderAfterLogin";
import Footer from "../../BusinessFooterAfterLogin";
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import {validatepromotion} from '../../../Utils/validate';

const AddPromotion = () => {
    const navigate = useNavigate();
    const [inputs,setInputs] = useState({start_date:'',promote_on:'',number_of_days:'',coupon_code:''});

    const [errors,setErrors] = useState({});

    useEffect(() => {
        document.title = `Add Promotion | Local Bells`;
        document.getElementById('bodywrap').className = 'busiaddpromo';
    }, []);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };

    /* Start Value set */
    const handleInputChange = (event) => {
      event.persist();
      setInputs(inputs => ({...inputs, [event.target.name]: event.target.value}));       
    }
    const handlePromoteChange = (e) => {
         const { value } = e.target;
         var lbl='promote_on';
         setInputs(prev => ({ ...prev, [lbl]: value }));
    }
    /* End Value set */
    const handleSubmit = (e) => {
        e.preventDefault();
             const validationErrors = validatepromotion(inputs);
         const noErrors = Object.keys(validationErrors).length === 0;
            setErrors({});
            setErrors(validationErrors);
            
            if(noErrors){
                navigate('/neighbour/view-gallery');
            }
            
      };



    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <BusinessSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible}/>
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <Row>
                                    <Col md={12} lg={12} xl={8}>
                                        <div className='white-box dp-box'>
                                            <div className="d-flex align-items-start justify-content-between gap-3">
                                               <h3>Deal Promotion</h3>
                                                <Link to="#" onClick={() => navigate(-1)} className='cross-up'>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid crosy" alt="wp" />
                                                </Link>
                                            </div>                                                                                        
                                            <h6 className='mb-4'>If you have any questions, feedback, or support needs, feel free to send us a message below.</h6>
                                            <h6 className='mb-4 '>Deal ID : <span className='fw-500'>757565-D1</span></h6>
                                            <h6 className='mb-4 d-none'>Promotion Start date : <span className='fw-500'>24 June, 2025</span></h6>
                                            <h6 className=''>Deal Description </h6>
                                            <h6 className='fw-500 mb-4 '>Lorem ipsum is placeholder text commonly used in the graphic,</h6>
                                            <div className='ap-form'>
                                                <Form onSubmit={handleSubmit}>
                                                    <Row className='mb-3'>
                                                        <Col md={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label className=''>Promotion Start date</Form.Label>
                                                                <Form.Control   
                                                                    placeholder="Select date "
                                                                    type={inputs.start_date ? 'date' : 'text'}                                                                
                                                                    value={inputs.start_date}
                                                                    onChange={handleInputChange}
                                                                    onFocus={(e) => (e.target.type = 'date')}
                                                                    onBlur={(e) => {
                                                                        if (!e.target.value) e.target.type = 'text';
                                                                    }}
                                                                    name="start_date"
                                                                />
                                                            </Form.Group> 
                                                           {errors.start_date && (<p className="text-danger">{errors.start_date}</p>)}                                                    
                                                        </Col>                                                        
                                                        <Col md={12}>
                                                            <Form.Label className=''>Promote on</Form.Label>
                                                        </Col>
                                                        <Col xl={6} xxl={6} lg={6} md={6}>
                                                            <div className="poll-radio">
                                                                <h6>Promote to appear on top of search</h6>
                                                                <div className="radio-wrapper">
                                                                    <input
                                                                        type="radio"
                                                                        id="pro-home"
                                                                        name="promote_on"
                                                                        value="promote_search"
                                                                        checked={inputs.promote_on === "promote_search"}
                                                                        onChange={handlePromoteChange}
                                                                    />
                                                                    <label htmlFor="pro-home" className={`radio-label ${inputs.promote_on === 'promote_search' ? 'checked' : ''}`}>
                                                                        {/*<Image
                                                                            src={inputs.promote_on === 'promote_search' ? "../assets/images/radio-checked.webp" : "../assets/images/radio.webp"}
                                                                            className="img-fluid"
                                                                            alt="radio state"
                                                                        />*/}
                                                                        <Image
  src={
    inputs.promote_on === 'promote_search'
      ? process.env.REACT_APP_BASE_URL + 'assets/images/radio-checked.webp'
      : process.env.REACT_APP_BASE_URL + 'assets/images/radio.webp'
  }
  className="img-fluid"
  alt="radio state"
/>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col  xl={6} xxl={6} lg={6} md={6}>
                                                            <div className="poll-radio" >
                                                                <h6>Promote to appear in Exclusive Deals Section</h6>
                                                                <div className="radio-wrapper">
                                                                    <input
                                                                        type="radio"
                                                                        id="pro-deal"
                                                                        name="promote_on"
                                                                        value="promote_deal"
                                                                        checked={inputs.promote_on === "promote_deal"}
                                                                        onChange={handlePromoteChange}
                                                                    />
                                                                    <label htmlFor="pro-deal" className={`radio-label ${inputs.promote_on === 'promote_deal' ? 'checked' : ''}`}>
                                                                        {/*<Image
                                                                            src={inputs.promote_on === 'promote_deal' ? "../assets/images/radio-checked.webp" : "../assets/images/radio.webp"}
                                                                            className="img-fluid"
                                                                            alt="radio state"
                                                                        />*/}
                                                                        <Image
                                                                          src={
                                                                            inputs.promote_on === 'promote_deal'
                                                                              ? process.env.REACT_APP_BASE_URL + 'assets/images/radio-checked.webp'
                                                                              : process.env.REACT_APP_BASE_URL + 'assets/images/radio.webp'
                                                                          }
                                                                          className="img-fluid"
                                                                          alt="radio state"
                                                                        />
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        {errors.promote_on && (<p className="text-danger">{errors.promote_on}</p>)}
                                                    </Row>
                                                    <Form.Label className=''>Number of Days</Form.Label>
                                                    <Form.Select aria-label="Default select example" name="number_of_days" onChange={handleInputChange} value={inputs.number_of_days}>
                                                        <option value=''>Select Number of days</option>
                                                        <option value="7">7 days</option>
                                                        <option value="14">14 days</option>
                                                        <option value="21">21 days</option>
                                                        <option value="30">30 days</option>
                                                    </Form.Select>
                                                    {errors.number_of_days && (<p className="text-danger">{errors.number_of_days}</p>)}
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className=''>Coupon Code</Form.Label>
                                                        <Form.Control type="text" placeholder="Enter your coupon code" name="coupon_code" onChange={handleInputChange} value={inputs.coupon_code} />
                                                        {errors.coupon_code && (<p className="text-danger">{errors.coupon_code}</p>)}
                                                    </Form.Group>


                                                    <Button type="submit" className='blue-btn'>Schedule Promotion</Button>
                                                </Form>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={12} lg={12} xl={4}>
                                        <div className='white-box cpb-box'>
                                            <div>
                                                <h3>Rs. 2,500</h3>
                                                <h6>Currant promotion balance</h6>
                                            </div>
                                            <Link to="/">Add balance</Link>
                                        </div>
                                        <div className='white-box ap-total-main'>
                                            <div className='ap-total-box'>
                                                <h6 className='ap-no-underline'>Total Promotion cost</h6>
                                            </div>
                                            <div className='ap-total-box'>
                                                <h6>Promote on Home Page </h6>
                                                <h6>Rs. 400</h6>
                                            </div>
                                            <div className='ap-total-box'>
                                                <h6>GST </h6>
                                                <h6>Rs. 0</h6>
                                            </div>
                                            <div className='ap-total-box'>
                                                <h6>Coupon Discount </h6>
                                                <h6>Rs. 40</h6>
                                            </div>
                                            <div className='ap-total-box'>
                                                <h6 className='fw-500 ap-no-underline'>Total</h6>
                                                <h6 className='fw-500'>Rs. 440</h6>
                                            </div>
                                        </div>
                                        <div className='ap-note'>
                                            <h6 className='fw-500 mb-2'>(Up to 5 Free Product Promotions at a time)</h6>
                                            <h6>Run a business promotion by Listing a business service/product with discounted price</h6>
                                        </div>
                                    </Col>
                                </Row>
                                <div className='footer-org footer'>
                                    <Footer />                                
                                </div>                                   
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default AddPromotion;


